const { REACT_APP_API_URL, REACT_APP_CLIENT_URL } = process.env;

export default {
  api: {
    baseURL: REACT_APP_API_URL
  },
  clientURL: REACT_APP_CLIENT_URL
};